import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { IPropertyEditorComboBoxApplicationEntity, PropertyEditorComboBoxApplicationEntity, PropertyEditorComboBoxApplicationEntityPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorComboBoxApplicationEntity";
import { NAMESPACE } from "./_Namespace";

export type PropertyEditorDocumentTemplatePropertyValues =
    PropertyEditorComboBoxApplicationEntityPropertyValues
    & {
    };

export type PropertyEditorDocumentTemplateProperties = {
    [name in keyof PropertyEditorDocumentTemplatePropertyValues]: Property<PropertyEditorDocumentTemplatePropertyValues[name]>
};

export interface IPropertyEditorDocumentTemplate extends IPropertyEditorComboBoxApplicationEntity, PropertyEditorDocumentTemplateProperties
{
}

export class PropertyEditorDocumentTemplate extends PropertyEditorComboBoxApplicationEntity implements IPropertyEditorDocumentTemplate
{
    // #region Static

    public static override classNamespace = NAMESPACE + "PropertyEditorDocumentTemplate";
    public static override className = "PropertyEditorDocumentTemplate";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<PropertyEditorDocumentTemplatePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                primaryEntity: "DocumentTemplates",
                primaryEntityDescriptionProperty: "name",
                propertyDisplayName: "Template",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<PropertyEditorDocumentTemplatePropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #endregion
}

